<template>
  <div class="proposal__wrap">
    <div class="section shadow filter__wrap">
      <div style="margin-bottom: 10px">
        <el-radio-group v-model="table.params.status" @change="handleTabs">
          <el-radio-button :label="2"
            >已通过({{ table.pass_total }})</el-radio-button
          >
          <el-radio-button :label="1"
            >待审核({{ table.checking_total }})</el-radio-button
          >
          <el-radio-button :label="3"
            >已拒绝({{ table.refuse_total }})</el-radio-button
          >
          <el-radio-button :label="4"
            >已取消({{ table.cancel_total }})</el-radio-button
          >
        </el-radio-group>
      </div>
      <div class="flex" style="margin-bottom: 10px">
        <el-form
          ref="elFormDom"
          inline
          :model="table.params"
          @submit.native.prevent="handleSearch"
        >
          <el-form-item label="注册号码" prop="account">
            <el-input
              clearable
              v-model.trim="table.params.account"
              placeholder="请输入"
              @keyup.enter.native.prevent="handleSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="education">
            <el-select
              clearable
              v-model.trim="table.params.education"
              placeholder="请输入"
              size="mini"
            >
              <el-option
                v-for="item in diplomaOpt"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" prop="school_id">
            <el-select
              v-model="table.params.school_id"
              clearable
              filterable
              @change="handleSearch"
            >
             <el-option
              v-for="item in schoolOption"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询
            </el-button>
            <el-button icon="el-icon-refresh-right" @click="reset"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table__wrap">
      <VTable
        has-pagionation
        ref="tableDom"
        title=""
        addText="添加"
        :field="getFields()"
        :loading="table.loading"
        :data="table.data"
        :page="table.params.page"
        :pageSize="table.params.count"
        :total="table.total"
        :tree-props="{ children: 'children', hasChildren: 'has_child' }"
        :hasPagionation="true"
        :default-expand-all="true"
        :showOverflowTooltip="true"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
      >
        <template v-slot:resume_reward="{ row }">
          <span>￥{{ row.resume_reward}}</span>
        </template>
        <template v-slot:action="{ row }">
          <template v-if="table.params.status == 2">
            <el-button type="text" @click="viewPassDetail(row)"
              >查看详情</el-button
            >
            <el-button type="text" @click="viewJianli(row)">简历</el-button>
          </template>
          <template v-if="table.params.status == 1">
            <el-button type="text" @click="viewReviewDialog(row)"
              >审核</el-button
            >
          </template>
          <template v-if="table.params.status == 3">
            <el-button type="text" @click="viewRefuseDialog(row)"
              >查看</el-button
            >
          </template>
          <template v-if="table.params.status == 4">
            <el-button type="text" @click="viewCancelDialog(row)"
              >查看</el-button
            >
          </template>
        </template>
      </VTable>
    </div>
    <passDetailDialog ref="passDetailDialogRef"></passDetailDialog>
    <reviewDialog ref="reviewDialogRef" @refresh="getTable"></reviewDialog>
    <refuseDialog ref="refuseDialogRef"></refuseDialog>
    <cancelDialog ref="cancelDialogRef"></cancelDialog>
    <jianliDetail ref="jianliDetailRef"></jianliDetail>
  </div>
</template>

<script>
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import passDetailDialog from "./components/passDetailDialog";
import reviewDialog from "./components/reviewDialog";
import refuseDialog from "./components/refuseDialog";
import cancelDialog from "./components/cancelDialog";
import jianliDetail from "./components/jianliDetail";
export default {
  mixins: [mixinTable],
  components: {
    VTable,
    passDetailDialog,
    reviewDialog,
    refuseDialog,
    cancelDialog,
    jianliDetail,
  },
  data() {
    return {
      defaultAvator: require("@/assets/img/default1.png"),
      schoolOption:[],
      diplomaOpt: [
        {
          id: 1,
          name: "大专",
        },
        {
          id: 2,
          name: "本科",
        },
        {
          id: 3,
          name: "硕士",
        },
        {
          id: 4,
          name: "博士",
        },
      ],
      field2: [
        { name: "nickname", label: "姓名", hidden: false },
        { name: "account", label: "注册号码", hidden: false },
        { name: "education_str", label: "学历", hidden: false },
        { name: "school_str", label: "毕业学校", hidden: false },
        { name: "major_str", label: "专业", hidden: false },
        {
          name: "college_type_str",
          label: "名校类别",
          hidden: false,
        },
        {
          name: "resume_reward",
          label: "简历奖励",
          hidden: false,
          width: "150",
        },
        { name: "check_time", label: "审核时间", hidden: false },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "150",
          hidden: false,
          fixed: "right",
        },
      ],
      field1: [
        { name: "nickname", label: "姓名", hidden: false },
        { name: "account", label: "注册号码", hidden: false },
        { name: "education_str", label: "学历", hidden: false },
        { name: "school_str", label: "毕业学校", hidden: false },
        { name: "major_str", label: "专业", hidden: false },
        {
          name: "college_type_str",
          label: "名校类别",
          hidden: false,
          width: "200",
        },
        { name: "create_time", label: "提交时间", hidden: false },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      field3: [
        { name: "nickname", label: "姓名", hidden: false },
        { name: "account", label: "注册号码", hidden: false },
        { name: "education_str", label: "学历", hidden: false },
        { name: "school_str", label: "毕业学校", hidden: false },
        { name: "major_str", label: "专业", hidden: false },
        {
          name: "college_type_str",
          label: "名校类别",
          hidden: false,
        },
        { name: "check_time", label: "拒绝时间", hidden: false },
        { name: "refuse_reason", label: "拒绝原因", hidden: false },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      field4: [
        { name: "nickname", label: "姓名", hidden: false },
        { name: "account", label: "注册号码", hidden: false },
        { name: "education_str", label: "学历", hidden: false },
        { name: "school_str", label: "毕业学校", hidden: false },
        { name: "major_str", label: "专业", hidden: false },
        {
          name: "college_type_str",
          label: "名校类别",
          hidden: false,
        },
        { name: "cancel_time", label: "取消时间", hidden: false },
        { name: "cancel_reason", label: "取消原因", hidden: false },
        { name: "", label: "", hidden: false, width: "1" },
        {
          name: "action",
          label: "操作",
          width: "60",
          hidden: false,
          fixed: "right",
        },
      ],
      table: {
        loading: false,
        params: {
          account:'',
          education:'',
          status: 2, //
          page: 1,
          count: 10,
        },
        data: [],
        total: 0,
        checking_total: 0,
        pass_total: 0,
        refuse_total: 0,
        cancel_total: 0,
      },
    };
  },
  created() {
    this.getTable();
    this.getSchoolOption();
  },
  methods: {
    getFields() {
      if (this.table.params.status === 1) {
        return this.field1;
      } else if (this.table.params.status === 2) {
        return this.field2;
      } else if (this.table.params.status === 3) {
        return this.field3;
      } else {
        return this.field4;
      }
    },
    reset() {
      this.$refs.elFormDom.resetFields();
      this.table.params.page = 1;
      this.getTable();
    },
    getTable() {
      this.$http
        .get("/admin/userAuth/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.data = res.data.list;
            this.table.total = res.data.total;
            this.table.cancel_total = res.data.cancel_total;
            this.table.checking_total = res.data.checking_total;
            this.table.pass_total = res.data.pass_total;
            this.table.refuse_total = res.data.refuse_total;
            this.$nextTick(() => {
              this.$refs.tableDom.$refs.multipleTable.doLayout();
            });
          }
        });
    },
    // 切换状态
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    viewPassDetail(row) {
      let dom = this.$refs.passDetailDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewReviewDialog(row) {
      let dom = this.$refs.reviewDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewRefuseDialog(row) {
      let dom = this.$refs.refuseDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewCancelDialog(row) {
      let dom = this.$refs.cancelDialogRef;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    viewJianli(row) {
      let dom = this.$refs.jianliDetailRef;
      dom.toggle(true);
      dom.getUserInfo(row);
      dom = null;
    }
  },
};
</script>

<style scoped lang="scss">
.flex {
  display: flex;
}
.proposal__wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
  padding: 20px;

  .filter__wrap {
    padding: 10px;
    margin-bottom: 20px;
    // display: flex;
    // justify-content: space-between;
  }

  .table__wrap {
    flex: 1;
    padding: 0;
    box-sizing: border-box;
  }
}
.title-box {
  display: flex;
  align-items: center;
  .title-box-right {
    margin-left: 8px;
  }
}
.title-box-right-1 {
  display: flex;
  align-items: center;
  .sex {
    margin-left: 8px;
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
}
.isman {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #25a5e2;
}
.iswomen {
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #ff8ba9;
}
.bage-box {
  height: 8px;
  width: 8px;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  background: #f56c6c;
  border-radius: 50%;
}
</style>